import UserFilterEnum from '../../../../types/user/UserFilterEnum';
import { SearchState, SearchActionTypes, TypesEnum } from './types';
import UserFilters from '../../../../types/user/UserFilters';
import { OptionsHelper } from '../../../../services/OptionsMapper';

const initialState: SearchState = {
    data: {
        [UserFilterEnum.Department]: [],
        [UserFilterEnum.Company]: [],
        [UserFilterEnum.Location]: [],
        [UserFilterEnum.DateInService]: [],
    },
    error: '',
    loading: false,
    filters: { FilterBy: UserFilterEnum.Company, Month: [], NameUser: '', page: 1, Values: [], Year: [] },
};

export function searchReducer(state = initialState, action: SearchActionTypes): SearchState {
    switch (action.type) {
        case TypesEnum.optionsRequested: {
            return { ...state, error: '', loading: true };
        }
        case TypesEnum.optionsReceived: {
            return { ...state, loading: false, data: action.payload };
        }
        case TypesEnum.optionsRequestFailed: {
            return { ...state, loading: false, error: action.payload };
        }
        case TypesEnum.filterByChanged: {
            const filters: UserFilters = {
                FilterBy: action.payload,
                page: 1,
                NameUser: '',
                Values: [],
                Month: [],
                Year: [],
            };

            return { ...state, filters };
        }
        case TypesEnum.searchNameChanged: {
            const filters: UserFilters = {
                ...state.filters,
                NameUser: action.payload,
                page: 1,
            };

            return { ...state, filters };
        }
        case TypesEnum.optionTriggered: {
            const filters: UserFilters = {
                ...state.filters,
                ...OptionsHelper[state.filters.FilterBy](state.filters, action.payload),
                page: 1,
            };

            return { ...state, filters };
        }
        case TypesEnum.filtersReset: {
            const filters = {
                ...state.filters,
                NameUser: '',
                Values: [],
                Month: [],
                Year: [],
            };

            return { ...state, filters };
        }
        default: {
            return state;
        }
    }
}
